module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-align-left-800d8d1d5179e2b88ea15b448f67b39b.png";